export const COLUMN_NAMES = {
  GROUP: 'group',
  COUNTS: 'counts',
  PERCENT: 'percent',
};
